import router from './../../router/index'
import Vue from 'vue'

const state = {
    loading: false
}
const mutations = {
    CHANGE_LOADING( state, _state ) {
        state.loading = _state
    }
}
const actions = {
    loader({ commit }, data) {
        commit('CHANGE_LOADING', data)
    },
    redirect({ commit }, data) {
        Vue.swal.close()
        if ( data.params !== undefined ) {
            router.push( {
                name: data.name,
                query: data.params
            } )
        } else {
            router.push({
                name: data
            })
        }
    },
    handleError({ commit }, data) {
        try {
            if (data === undefined) {
                return
            }
            if (
                data.response !== undefined &&
                data.response.message !== undefined &&
                data.response.message.includes( "Cannot read property" )
            ) {
                Vue.swal({
                    imageUrl: "/images/svg/Error.svg",
                    allowEscapeKey: true,
                    showConfirmButton: false,
                    allowOutsideClick: true,
                    showCancelButton: true,
                    cancelButtonColor: '#f33',
                    cancelButtonText: 'OK',
                    title: "Check your internet connection"
                })
                return
            }
            let dataResponse = data.response !== undefined ? data.response  : data
            if ( dataResponse !== undefined && dataResponse.message !== undefined ) {
                if (dataResponse.message === "Please verify your phone number to continue." ||
                    dataResponse.message === "jwt expired" ||
                    dataResponse.error === "jwt expired"
                ) {
                    return null;
                }
            }
            let callback = data.callback ? data.callback : null
            let can_cancel = data.can_cancel ? data.can_cancel : false
            if (dataResponse.message === "OTP has already been used") {
                dataResponse.message = "OTP has already been used. Please click on resend SMS."
            }
            let title = dataResponse.data !== undefined && dataResponse.data !== null ? (dataResponse.data.error !== undefined ? dataResponse.data.error : dataResponse.message) : dataResponse.message
            // this is necessary to prevent sweet alert from returning focus to last input after closing
            document.activeElement.blur();

            Vue.swal({
                imageUrl: "/images/svg/Error.svg",
                title,
                allowEscapeKey: can_cancel,
                showConfirmButton: false,
                confirmButtonText: 'Retry',
                allowOutsideClick: can_cancel,
                showCancelButton: true,
                cancelButtonText: 'Cancel',
            })
            .then(result => {
                if(result.value) {
                    if (callback !== null) {
                        callback();
                    }
                }
            }).finally(() => {
                if(data.pincodeRef) {
                    data.pincodeRef.reset()
                }
            })
        } catch(e) {
            Vue.swal({
                imageUrl: "/images/svg/Error.svg",
                allowEscapeKey: true,
                showConfirmButton: false,
                allowOutsideClick: true,
                showCancelButton: true,
                cancelButtonColor: '#f33',
                cancelButtonText: 'OK',
                title: "Check your Internet connection."
            })
        }

    },
}

export default {
    state,
    mutations,
    actions
}
